import { Component } from '@theme/component';

/**
 * A custom element that manages a delivery promise.
 */
export class DeliveryPromiseComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    const sendcloudConfig = Theme.sendcloud_config;
    const {
      from_country_code: fromCountryCode,
      to_country_code: toCountryCode,
      estimation_time_min: estimationTimeMin,
      estimation_time_max: estimationTimeMax,
      delivery_method_type: deliveryMethodType,
      delivery_promise_separator: deliveryPromiseSeparator,
    } = sendcloudConfig;
    const { productWeight, productPrice, additionalDays } = this.dataset;

    if (!fromCountryCode || !toCountryCode || !estimationTimeMin || !estimationTimeMax) return;

    fetch('/apps/kamera/api/sendcloud/delivery-options', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        from_address: { country_code: fromCountryCode },
        to_address: { country_code: toCountryCode },
        total_weight: { value: productWeight || 0, unit: 'g' },
        total_price: { value: productPrice || 0 },
      }),
    })
      .then((response) => response.json())
      .then(({ delivery_options = [] }) => {
        const target_delivery_option = delivery_options
          .filter((delivery_option) =>
            deliveryMethodType ? delivery_option.delivery_method_type === deliveryMethodType : true,
          )
          .sort(
            (delivery_option_a, delivery_option_b) =>
              delivery_option_a.lead_time_hours[estimationTimeMin] -
              delivery_option_b.lead_time_hours[estimationTimeMin],
          )
          .at(0);
        const result =
          target_delivery_option.lead_time_hours[estimationTimeMin] ===
          target_delivery_option.lead_time_hours[estimationTimeMax]
            ? target_delivery_option.lead_time_hours[estimationTimeMin] / 24 + +additionalDays
            : `${target_delivery_option.lead_time_hours[estimationTimeMin] / 24 + +additionalDays} ${deliveryPromiseSeparator || '-'} ${target_delivery_option.lead_time_hours[estimationTimeMax] / 24 + +additionalDays}`;

        this.innerText = this.innerText.replace('[delivery_promise]', result);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.classList.add('ready');
      });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }
}

if (!customElements.get('delivery-promise')) customElements.define('delivery-promise', DeliveryPromiseComponent);
